import { createSafeContext } from "~/contexts";
import type { DataStore } from "~/dsm";

export const [useCurrentDataStore, CurrentDataStoreContext] =
  createSafeContext<DataStore>("CurrentDataStore");
